const RL_SETTINGS_ETAG_KEY = "BT_AM_SETTINGS_ETAG";

export const getSettingsEtag = () =>
  sessionStorage.getItem(RL_SETTINGS_ETAG_KEY);

export const saveSettingsEtag = (etag: string) =>
  sessionStorage.setItem(RL_SETTINGS_ETAG_KEY, etag);
export const deleteSettingsEtag = () =>
  sessionStorage.removeItem(RL_SETTINGS_ETAG_KEY);
